import { render, staticRenderFns } from "./ImportPostTags.vue?vue&type=template&id=db9971c0&scoped=true&class=import-post-tags&"
import script from "./ImportPostTags.vue?vue&type=script&lang=js&"
export * from "./ImportPostTags.vue?vue&type=script&lang=js&"
import style0 from "./ImportPostTags.vue?vue&type=style&index=0&id=db9971c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db9971c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VCol } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFileInput } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VListItem } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VCard,VCardActions,VCardText,VChip,VCol,VDialog,VFileInput,VForm,VListItem,VRow})
